import { renderAutocompleteField } from "components/AutocompleteInput";
import { HouseNumberInput } from "components/HouseNumberInput";
import { Input } from "components/Input";
import { formatPhoneNumber } from "utils/helpers";
import { ALIViewProps } from "../ALIForm";
import { ADDLDataSection } from "./ADDLEditViews";

export function ALIChangeRequestView({
  recordRequest,
  setRecordRequest,
  record,
  handleChange,
  hasAddlDataPermission,
  addlDataRequest,
  setAddlDataRequest,
  lastFired,
  lastMSAGRecord,
  setLastMSAGRecord,
  availableOptions,
  setAvailableOptions,
  validationErrors,
  setValidationErrors,
  mode,
}: ALIViewProps) {
  return (
    <div style={{ padding: "20px", paddingBottom: "40px" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "100px",
        }}
      >
        {/* Left Column */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <Input
            name="CPN"
            label="Telephone Number*"
            value={formatPhoneNumber(record.CPN || "")}
            readonly={mode === "edit" ? true : false}
            scale="s"
            labelSize="s"
          />
          <Input
            name="NAM"
            label="Customer Name*"
            value={recordRequest.NAM ?? record.NAM ?? ""}
            onChange={handleChange}
            scale="s"
            labelSize="s"
            max={32}
          />

          {renderAutocompleteField(
            "STA",
            "State*",
            "State",
            recordRequest,
            setRecordRequest,
            lastMSAGRecord,
            setLastMSAGRecord,
            availableOptions,
            setAvailableOptions,
            lastFired,
            validationErrors,
            setValidationErrors,
            false,
            mode === "edit" ? true : false,
            mode === "create" || mode === "migrate" ? true : false,
          )}
          {renderAutocompleteField(
            "MCN",
            "MSAG Community Name*",
            "MCN",
            recordRequest,
            setRecordRequest,
            lastMSAGRecord,
            setLastMSAGRecord,
            availableOptions,
            setAvailableOptions,
            lastFired,
            validationErrors,
            setValidationErrors,
            false,
            mode === "edit" ? true : false,
            mode === "create" || mode === "migrate" ? true : false,
          )}
          {renderAutocompleteField(
            "STN",
            "Street Name*",
            "StreetName",
            recordRequest,
            setRecordRequest,
            lastMSAGRecord,
            setLastMSAGRecord,
            availableOptions,
            setAvailableOptions,
            lastFired,
            validationErrors,
            setValidationErrors,
            false,
            mode === "edit" ? true : false,
            mode === "create" || mode === "migrate" ? true : false,
          )}
          {renderAutocompleteField(
            "STS",
            "Street Suffix*",
            "StreetSuffix",
            recordRequest,
            setRecordRequest,
            lastMSAGRecord,
            setLastMSAGRecord,
            availableOptions,
            setAvailableOptions,
            lastFired,
            validationErrors,
            setValidationErrors,
            false,
            mode === "edit" ? true : false,
            mode === "create" || mode === "migrate" ? true : false,
          )}

          <Input
            name="PRD"
            label="Prefix Directional"
            value={recordRequest.PRD ?? record.PRD ?? ""}
            onChange={handleChange}
            scale="s"
            labelSize="s"
            max={2}
          />
          <Input
            name="POD"
            label="Post Directional"
            value={recordRequest.POD ?? record.POD ?? ""}
            onChange={handleChange}
            scale="s"
            labelSize="s"
            max={2}
          />
          <HouseNumberInput
            recordRequest={recordRequest}
            setRecordRequest={setRecordRequest}
            lastMSAGRecord={lastMSAGRecord}
          />
          <Input
            name="HNS"
            label="House Number Suffix"
            value={recordRequest.HNS ?? record.HNS ?? ""}
            onChange={handleChange}
            scale="s"
            labelSize="s"
            max={4}
          />
        </div>

        {/* Right Column */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <Input
            name="ESN"
            label="Emergency Service Number"
            value={recordRequest.lecESN ?? record.lecESN ?? ""}
            onChange={handleChange}
            readonly={mode === "edit" ? true : false}
            scale="s"
            labelSize="s"
          />
          <Input
            name="LOC"
            label="Location"
            value={recordRequest.LOC ?? record.LOC ?? ""}
            onChange={handleChange}
            scale="s"
            labelSize="s"
            max={60}
          />
          <Input
            name="Comments"
            label="Comments"
            value={recordRequest.Comments ?? record.Comments ?? ""}
            onChange={handleChange}
            scale="s"
            labelSize="s"
            max={30}
          />

          {hasAddlDataPermission && (
            <ADDLDataSection
              addlDataRequest={addlDataRequest}
              setAddlDataRequest={setAddlDataRequest}
              record={record}
            />
          )}

          <Input
            name="NOTES"
            label="Notes"
            scale="s"
            labelSize="s"
            value={recordRequest.NOTES ?? record.NOTES ?? ""}
            onChange={handleChange}
            type="textarea"
          />
        </div>
      </div>
    </div>
  );
}
